export default "__VITE_ASSET__VaoWGX3z__"